import { render } from "./Pago.vue?vue&type=template&id=11bdb1e9&scoped=true"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=11bdb1e9&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11bdb1e9"]])

export default __exports__